export default __webpack_public_path__ + "static/media/ic_less.d87c10b8.svg";